// extracted by mini-css-extract-plugin
module.exports = {"Timer__wrapper":"Timer_Timer__wrapper__1q1w6"};